import { ConsoleStyler } from 'ursys/client';

/// CONSTANTS ///

const PR = ConsoleStyler('Day02','TagPink');
const LOG = console.log.bind(console);

/// LIFECYCLE ///

addEventListener("load", (event) => {
  LOG(...PR(`It's Day 02 for another Build!!!`));

  // draw a red box inside the #container SVG element
  const container = document.getElementById('container');
  if (container) {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('y', '10');
    rect.setAttribute('width', '100');
    rect.setAttribute('height', '100');
    rect.setAttribute('fill', 'red');
    container.appendChild(rect);

    // animate left to right and back
    let x = 10;
    let direction = 1;
    const speed = 0.5;
    const containerWidth = container.clientWidth || 500;
    const rectWidth = 100;
    const maxX = containerWidth - rectWidth - 10;

    const u_animate = () => {
      x += speed * direction;
      if (x >= maxX) direction = -1;
      if (x <= 10) direction = 1;
      rect.setAttribute('x', String(x));
      requestAnimationFrame(u_animate);
    };

    requestAnimationFrame(u_animate);
  }

})
